export default {
  async all(config = {}) {
    return await this.$get({
      url: `${this.$baseurl}/configurations`,
      headers: this.headers,
      ...config,
    });
  },
};
